import React, { useMemo, useState, useEffect } from "react";
import DataTable from "../_Components/DataTable";
import _ from "lodash";
import { Link, useLocation } from "react-router-dom";
import Switch from "@mui/material/Switch";
import CreateOrEditAmusementGroup from "./CreateOrEdit";
import { Button } from "react-bootstrap";

function DataGrid({ data, setShowModalGroup, setSelectedGroupId, setShowModalAmusementsOrder }) {
  const columns = useMemo(
    () => [
      {
        accessor: "id",
        Header: "#",
        minWidth: 50,
      },
      {
        accessor: "title",
        Header: "عنوان",
        minWidth: 120,
      },
      {
        accessor: "urlName",
        Header: "urlName",
        minWidth: 120,
      },
      {
        accessor: "indexView",
        Header: "ترتیب نمایش",
        minWidth: 50,
      },
      {
        Header: "وضعیت",
        minWidth: "100px",
        align: "center",
        Cell: ({ row }) => (
          <div className="text-center">
            <Switch
              checked={row.original.status ? true : false}
              //checked={state.checkedA}
              value="row.original.active"
              color="primary"
              inputProps={{ "aria-label": "primary checkbox" }}
              // onChange={handleChange(row.original)}
            />
          </div>
        ),
      },

      {
        accessor: "createdPersianTime",
        Header: "زمان ایجاد",
        minWidth: 90,
        maxWidth: 90,
      },
      // {
      //     accessor: "",
      //     Header: "نمایش",
      //     minWidth: 70,
      //     Cell: ({ row: { original } }) => (
      //         <>
      //             <Switch
      //                 checked='{status}'
      //                 value="checkedB"
      //                 color="primary"
      //                 inputProps={{ 'aria-label': 'primary checkbox' }}
      //             />
      //             {/* <i className='fas fa-check text-success '></i> */}
      //             {/* <i className='fas fa-times text-danger '></i> */}
      //         </>
      //     )
      // },
      {
        Header: "عملیات",
        accessor: "",
        minWidth: 150,
        align: "center",
        Cell: ({ row }) => (
          <div className="text-center">
            <Button
              className="btn btn-light-primary btn-sm mr-2 btn-icon"
              title="ویرایش"
              onClick={() => {
                setSelectedGroupId(row.original.id);
                setShowModalGroup(true);
              }}
            >
              <i className="far fa-edit text-small"></i>
            </Button>

            {/* ترتیب سرویس ها در هر گروه*/}
            <Button
              className="btn btn-light-success btn-sm mr-2 btn-icon"
              title="ترتیب نمایش"
              onClick={() => {
                setSelectedGroupId(row.original.id);
                setShowModalAmusementsOrder(true);
              }}
            >
              <i className="fas fa-sort-up text-small"></i>
              <i className="fas fa-sort-down text-small"></i>
            </Button>
          </div>
        ),
      },
    ],
    [],
  );

  const config = {
    page_size: 10,
    length_menu: [10, 20, 50, 100],
    show_filter: false,
    show_pagination: true,
    pagination: "advance",
    button: {
      excel: false,
      print: false,
    },
    language: {
      length_menu: " _MENU_  رکورد در هر صفحه",
      filter: "جستجو ...",
      info: " _START_ - _END_ از _TOTAL_ رکورد",
      pagination: {
        first: "First",
        previous: <i className="fa fa-chevron-right"></i>,
        next: <i className="fa fa-chevron-left"></i>,
        last: "Last",
      },
    },
  };
  return (
    <div>
      <DataTable config={config} columns={columns} data={data} />
    </div>
  );
}

export default DataGrid;
